(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('custom-terrain-type-attribute', {
            parent: 'entity',
            url: '/custom-terrain-type-attribute?page&sort&search',
            data: {
                authorities: [ 'ENTITY_CONFIGURATION' ],
                pageTitle: 'trakeyeApp.customTerrainTypeAttribute.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/custom-terrain-type-attribute/custom-terrain-type-attributes.html',
                    controller: 'CustomTerrainTypeAttributeController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('customTerrainTypeAttribute');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('custom-terrain-type-attribute-detail', {
            parent: 'custom-terrain-type-attribute',
            url: '/custom-terrain-type-attribute/{id}',
            data: {
                authorities: [ 'ENTITY_CONFIGURATION' ],
                pageTitle: 'trakeyeApp.customTerrainTypeAttribute.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/custom-terrain-type-attribute/custom-terrain-type-attribute-detail.html',
                    controller: 'CustomTerrainTypeAttributeDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('customTerrainTypeAttribute');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'CustomTerrainTypeAttribute', function($stateParams, CustomTerrainTypeAttribute) {
                    return CustomTerrainTypeAttribute.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'custom-terrain-type-attribute',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        /*.state('custom-terrain-type-attribute-detail.edit', {
            parent: 'custom-terrain-type-attribute-detail',
            url: '/detail/edit',
            data: {
                authorities: [ 'ENTITY_CONFIGURATION' ]
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/custom-terrain-type-attribute/custom-terrain-type-attribute-dialog.html',
                    controller: 'CustomTerrainTypeAttributeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['CustomTerrainTypeAttribute', function(CustomTerrainTypeAttribute) {
                            return CustomTerrainTypeAttribute.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })*/
        /*.state('custom-terrain-type-attribute.new', {
            parent: 'custom-terrain-type-attribute',
            url: '/new',
            data: {
                authorities: [ 'ENTITY_CONFIGURATION' ]
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/custom-terrain-type-attribute/custom-terrain-type-attribute-dialog.html',
                    controller: 'CustomTerrainTypeAttributeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                description: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('custom-terrain-type-attribute', null, { reload: 'custom-terrain-type-attribute' });
                }, function() {
                    $state.go('custom-terrain-type-attribute');
                });
            }]
        })*/
        
        .state('custom-terrain-type-attribute.new', {
			parent : 'custom-terrain-type-attribute',
			url : '/new',
			data : {
				authorities : [ 'ENTITY_CONFIGURATION' ]
			},
			views : {
				'content@' : {
					templateUrl: 'app/entities/custom-terrain-type-attribute/custom-terrain-type-attribute-dialog.html',
                    controller: 'CustomTerrainTypeAttributeDialogController',
                    controllerAs: 'vm',
				}
			},
			resolve : {
				entity : function() {
					return {
						name : null,
						description : null,
						id : null
					};
				}
			}
		})
        /*.state('custom-terrain-type-attribute.edit', {
            parent: 'custom-terrain-type-attribute',
            url: '/{id}/edit',
            data: {
                authorities: [ 'ENTITY_CONFIGURATION' ]
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/custom-terrain-type-attribute/custom-terrain-type-attribute-dialog.html',
                    controller: 'CustomTerrainTypeAttributeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['CustomTerrainTypeAttribute', function(CustomTerrainTypeAttribute) {
                            return CustomTerrainTypeAttribute.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('custom-terrain-type-attribute', null, { reload: 'custom-terrain-type-attribute' });
                }, function() {
                    $state.go('^');
                });
            }]
        })*/
		
		.state('custom-terrain-type-attribute.edit', {
			parent : 'custom-terrain-type-attribute',
			url : '/{id}/edit',
			data : {
				authorities : [ 'ENTITY_CONFIGURATION' ],
				pageTitle : 'trakeyeApp.customTerrainTypeAttribute.home.title'
			},
			views : {
				'content@' : {
					templateUrl: 'app/entities/custom-terrain-type-attribute/custom-terrain-type-attribute-dialog.html',
                    controller: 'CustomTerrainTypeAttributeDialogController',
                    controllerAs: 'vm'
				}
			},
			resolve : {
				translatePartialLoader : [ '$translate', '$translatePartialLoader', function($translate, $translatePartialLoader) {
					$translatePartialLoader.addPart('customTerrainTypeAttribute');
					return $translate.refresh();
				} ],
				entity : [ '$stateParams', 'CustomTerrainTypeAttribute', function($stateParams, CustomTerrainTypeAttribute) {
					return CustomTerrainTypeAttribute.get({
						id : $stateParams.id
					}).$promise;
				} ],
				previousState : [ "$state", function($state) {
					var currentStateData = {
						name : $state.current.name || 'custom-terrain-type-attribute',
						params : $state.params,
						url : $state.href($state.current.name, $state.params)
					};
					return currentStateData;
				} ]
			}
		})
        .state('custom-terrain-type-attribute.delete', {
            parent: 'custom-terrain-type-attribute',
            url: '/{id}/delete',
            data: {
                authorities: [ 'ENTITY_CONFIGURATION' ],
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/custom-terrain-type-attribute/custom-terrain-type-attribute-delete-dialog.html',
                    controller: 'CustomTerrainTypeAttributeDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['CustomTerrainTypeAttribute', function(CustomTerrainTypeAttribute) {
                            return CustomTerrainTypeAttribute.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('custom-terrain-type-attribute', null, { reload: 'custom-terrain-type-attribute' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();


/*(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('custom-terrain-type-attribute', {
            parent: 'entity',
            url: '/custom-terrain-type-attribute?page&sort&search',
            data: {
                authorities: [ 'ENTITY_CONFIGURATION' ],
                pageTitle: 'trakeyeApp.customTerrainTypeAttribute.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/custom-terrain-type-attribute/custom-terrain-type-attributes.html',
                    controller: 'CustomTerrainTypeAttributeController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('customTerrainTypeAttribute');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('custom-terrain-type-attribute-detail', {
            parent: 'custom-terrain-type-attribute',
            url: '/custom-terrain-type-attribute/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'trakeyeApp.customTerrainTypeAttribute.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/custom-terrain-type-attribute/custom-terrain-type-attribute-detail.html',
                    controller: 'CustomTerrainTypeAttributeDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('customTerrainTypeAttribute');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'CustomTerrainTypeAttribute', function($stateParams, CustomTerrainTypeAttribute) {
                    return CustomTerrainTypeAttribute.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'custom-terrain-type-attribute',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('custom-terrain-type-attribute-detail.edit', {
            parent: 'custom-terrain-type-attribute-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/custom-terrain-type-attribute/custom-terrain-type-attribute-dialog.html',
                    controller: 'CustomTerrainTypeAttributeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['CustomTerrainTypeAttribute', function(CustomTerrainTypeAttribute) {
                            return CustomTerrainTypeAttribute.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('custom-terrain-type-attribute.new', {
            parent: 'custom-terrain-type-attribute',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/custom-terrain-type-attribute/custom-terrain-type-attribute-dialog.html',
                    controller: 'CustomTerrainTypeAttributeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                description: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('custom-terrain-type-attribute', null, { reload: 'custom-terrain-type-attribute' });
                }, function() {
                    $state.go('custom-terrain-type-attribute');
                });
            }]
        })
        .state('custom-terrain-type-attribute.edit', {
            parent: 'custom-terrain-type-attribute',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/custom-terrain-type-attribute/custom-terrain-type-attribute-dialog.html',
                    controller: 'CustomTerrainTypeAttributeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['CustomTerrainTypeAttribute', function(CustomTerrainTypeAttribute) {
                            return CustomTerrainTypeAttribute.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('custom-terrain-type-attribute', null, { reload: 'custom-terrain-type-attribute' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('custom-terrain-type-attribute.delete', {
            parent: 'custom-terrain-type-attribute',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/custom-terrain-type-attribute/custom-terrain-type-attribute-delete-dialog.html',
                    controller: 'CustomTerrainTypeAttributeDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['CustomTerrainTypeAttribute', function(CustomTerrainTypeAttribute) {
                            return CustomTerrainTypeAttribute.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('custom-terrain-type-attribute', null, { reload: 'custom-terrain-type-attribute' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();*/
